export type HeroPinterestImage = {
  src: string;
  h: string;
};

/** Duplicate a column so CSS can loop with translateY(-50%). */
export function loopHeroPinterestTrack<T>(items: readonly T[]): T[] {
  return [...items, ...items];
}

/** Two images per column → 12 DOM nodes (was 30). */
export const HERO_PIN_COL1: readonly HeroPinterestImage[] = [
  { src: 'https://i.pinimg.com/736x/c0/a7/be/c0a7be3d7ee7d6ee51f7ac3880e5e5e5.jpg', h: 'h-64' },
  { src: 'https://i.pinimg.com/736x/f4/8f/11/f48f118359871b62d44c0bafe9cf4961.jpg', h: 'h-80' },
];

export const HERO_PIN_COL2: readonly HeroPinterestImage[] = [
  { src: 'https://i.pinimg.com/736x/e5/7f/f5/e57ff5b82224d6ed300e032aa8bcb653.jpg', h: 'h-72' },
  { src: 'https://i.pinimg.com/736x/b3/6e/6c/b36e6c00c6d8c5a3ab167c4266808450.jpg', h: 'h-96' },
];

export const HERO_PIN_COL3: readonly HeroPinterestImage[] = [
  { src: 'https://i.pinimg.com/736x/29/1c/35/291c352e3a5d6a6faf15c31a9c90bcd8.jpg', h: 'h-80' },
  { src: 'https://i.pinimg.com/736x/84/25/9e/84259e91c13c7fe79a7f980e85a6f245.jpg', h: 'h-96' },
];

export const HERO_MOBILE_IMAGES: readonly HeroPinterestImage[] = [
  { src: 'https://i.pinimg.com/736x/c0/a7/be/c0a7be3d7ee7d6ee51f7ac3880e5e5e5.jpg', h: 'h-40' },
  { src: 'https://i.pinimg.com/736x/f4/8f/11/f48f118359871b62d44c0bafe9cf4961.jpg', h: 'h-56' },
  { src: 'https://i.pinimg.com/736x/68/fe/f8/68fef885052e09d6a6446269f8b55404.jpg', h: 'h-48' },
  { src: 'https://i.pinimg.com/736x/90/ba/2b/90ba2b569a6cf0d67d76a2af13f574b8.jpg', h: 'h-52' },
];
